// START Open Require.JS wrapper
define([
	'jquery',
	'pubsub',
	'wcs.context',
	'shared.main.screen'
], function($,pubsub, ctx, screenSize) {
// END Open Require.JS wrapper


/****
* Shows/hides search container by clicking the search button
* visible on small devices.
***/

	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "searchButton";
	var searchButton;
	var transparentNavToggle = false;
	var updatePageNameBasedOnPreviousPage = WCS_CONFIG.get("global::updatePageNameBasedOnPreviousPage") || false;
	var enableMobileTopNavForTablet = WCS_CONFIG.get('topnav::enableMobileTopNavForTablet') || false;
	var isTabletDevice = (window.devicePixelRatio >= 2 && (window.innerWidth >= 640 && window.innerWidth <= 1024)) && enableMobileTopNavForTablet;
	
	(function(){
		searchButton = {
			defaults: {
				dataAttr: "search-button-options",
				accordion: ".topnav-accordion",
				searchButton: ".topnav-searchbutton",
				searchButtonIcon: ".topnav-searchbutton span",
				searchContainer: ".topnav-search-container",
				searchInput: ".topnav-search-input",
				searchForm: ".topnav-search-form",
				searchSubmitButton: ".topnav-search-button",
				searchSubmitButtonIcon: ".icon-search",
				topnav: '.topnav',
				searchResultsCloseBtn: "autosuggest-overlay-close",
				closeTooltip: ".syte-camera-tooltip-close-button",
				tooltipWrapper: ".syte-camera-tooltip-wrapper",
				topNavNewHeader: '.top-nav-header'
			},

			/**
			 * Initialize Main search Button Functions
			 **/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this; // Make plugin namespace available throughout
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.searchButton);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );

				self.config.$accordion = $(self.config.accordion);
				self.config.$searchButton = $(self.config.searchButton);
				self.config.$searchButtonLink = self.config.$searchButton.find('a');
				self.config.$searchButtonAriaOpen = $(self.config.$searchButtonLink).attr('aria-label');
				self.config.$searchButtonAriaClose = $(self.config.$searchButtonLink).data('closeAriaLabel');
				self.config.$searchButtonIcon = $(self.config.searchButtonIcon);
				self.config.$searchContainer = $(self.config.searchContainer);
				self.config.$searchInput = $(self.config.searchInput);
				self.config.$searchForm = $(self.config.searchForm);
				self.config.$searchSubmitButton = $(self.config.searchSubmitButton);
				self.config.$searchSubmitButtonIcon = self.config.$searchSubmitButton.find(self.config.searchSubmitButtonIcon);
				self.config.hasMobileClearSearchButton = self.config.$searchSubmitButton.hasClass('clear-search');
				self.config.$closeTooltip = $(self.config.closeTooltip);
				self.config.$tooltipWrapper = $(self.config.tooltipWrapper);
				self.config.$header = self.$element;
				self.config.$topnav = self.config.$header.closest(self.config.topnav);

				if(self.config.$topnav.closest('.transperant-topnav').length) {
                    transparentNavToggle = true;
                }

				self.events();

				self.configureAriaTags();

				self.configureSearchForm();

				self.deferred.resolve();

				return self;
			},

			/**
			 * Initilize specific plugins
			 **/
			events : function() {
				var self = this;

				// native validation is disabled so prevent search form submission when blank
				self.config.$searchForm.on('submit', function(e) {
					if (updatePageNameBasedOnPreviousPage) {
						ctx.setCookie('searchTriggered', true);
					}

					if(self.config.$searchInput.val() == "") {
						e.preventDefault();
					}
				});

				self.config.$searchInput.on('focus', function() {
					self.config.$searchForm.addClass('focus');
				});

				self.config.$searchInput.on('blur', function(event) {
					self.config.$searchForm.removeClass('focus');
				});

				// toggle search drawer on small screens
				self.config.$searchButton.on('click touch', function(e) {
					e.preventDefault();
					self.toggleSearchContainer(self.config.$searchContainer);
				});

				// tooltip close
				self.config.$closeTooltip.on('click', function() {
					self.config.$tooltipWrapper.css("display", "none");
					// setting time out function to remove the inline style property( display ) after 0.5 seconds
					setTimeout(function() {
						self.config.$tooltipWrapper.css("display", "");
					}, 500);
				});

				// Close small screen search if visitor resizes out of the breakpoint
				$.pubsub('subscribe','window.resize.breakpoint',function(event,data) {
					if(data.now !== 'small') {
						self.hideSearch();
					}

					self.configureAriaTags();
					self.configureSearchForm();
				});

				// clear out search field
				if(self.config.hasMobileClearSearchButton) {
					self.config.$searchSubmitButton.on('click touch', function(e) {
						if(screenSize.size() === "small" || isTabletDevice) {
							e.preventDefault();
							self.config.$searchInput.val('');
						}
					});
				}

				var inputField = document.querySelector(".topnav-search-input");
				var clearBtn = document.querySelector(".topnav-clear-input");

				if(clearBtn) {
					clearBtn.addEventListener("click", function() {
						inputField.value = "";
						clearBtn.style.display = "none";
					});

					inputField.addEventListener("input", function() {
						if (inputField.value !== "") {
							clearBtn.style.display = "block";
						} else {
							clearBtn.style.display = "none";
						}
					});
				}
			},
			
			toggleTransperantTopNav: function(navState) {
                if(!transparentNavToggle) return;
                
                var self = this,
                topNavNewBar = $(self.config.topNavNewHeader);

                if(navState == 'show') {
                    topNavNewBar.addClass('new-transperant-topnav')
                }else{
                    topNavNewBar.removeClass('new-transperant-topnav')
                }   
            },

			// configure the aria-labelledby attribute for proper accessibility controls
			// since the search container is only hidden on small screens
			configureAriaTags : function() {
				var self = this;

				if(screenSize.size() !== "small") {
					self.config.$searchContainer.removeAttr('aria-labelledby');
				}
				else {
					self.config.$searchContainer.attr({'aria-labelledby':'topnav-search-button'});
				}
			},

			configureSearchForm : function() {
				var self = this;
				if((screenSize.size() === "small" || isTabletDevice) && self.config.hasMobileClearSearchButton) {
					self.config.$searchSubmitButton.addClass('search-clear-button');
					self.config.$searchSubmitButtonIcon.addClass('icon-close');
					self.config.$searchSubmitButtonIcon.removeClass('icon-search');
				}
				else {
					self.config.$searchSubmitButton.removeClass('search-clear-button');
					self.config.$searchSubmitButtonIcon.removeClass('icon-close');
					self.config.$searchSubmitButtonIcon.addClass('icon-search');
				}
			},

			toggleSearchContainer : function(el) {
				var self = this;
				if (screenSize.size() === "small" || isTabletDevice) {
					if(self.config.$searchButton.hasClass('active')) {
						self.hideSearch();
					} else {
						self.showSearch();
					}
				} else {
					self.showSearch();
				}
			},

			hideSearch: function() {
				var self = this;

				$.pubsub('publish', 'vfdp.aem.topnav.search.close');

				if (window.topnavSearchClickHandler) {
					$(document).off('click touch', window.topnavSearchClickHandler);
				}

				self.config.$searchButton.removeClass('active');
				self.config.$searchButtonLink.attr({
					'aria-expanded':'false',
					'aria-label':self.config.$searchButtonAriaOpen
				});
				self.config.$searchButtonIcon.removeClass('icon-close').addClass('icon-search');

				// don't hide the search container if the accordion menu is visible and has search enabled
				if(self.config.$accordion.is(':visible') && self.config.$accordion.hasClass('topnav-accordion-search') && !self.config.$accordion.hasClass('scrolled')) {
					return;
				}
				self.toggleTransperantTopNav('hide');
				self.config.$searchContainer.removeClass('active');
			},

			showSearch: function() {
				var self = this;

				$.pubsub('publish','vfdp.aem.topnav.search.open');

				// Close search container if user clicks outside the of it
				window.topnavSearchClickHandler = function(e) {
					var $target = $(e.target);
					
					if ($($target).hasClass('active') && $target.attr('id') === 'topnav-search-container' || (!$target.closest(self.config.searchContainer).length && !$target.closest(self.config.searchButton).length && !$target.hasClass(self.config.searchResultsCloseBtn)) ) {
						self.hideSearch();
					}
				};
				$(document).on('click touch', window.topnavSearchClickHandler);

				// Allow the space key press to open the search box
				var topnavSearchKeyUpHandler = function(e) {
					if(e.keyCode == 32 || e.keyCode == 13) {
						e.preventDefault();
						topnavSearchClickHandler(e);
					}
				};
				self.config.$searchButton.on('keyup', topnavSearchKeyUpHandler);

				self.config.$searchContainer.addClass('active');
				self.config.$searchButton.addClass('active');
				self.config.$searchButtonLink.attr({
					'aria-expanded':'true',
					'aria-label':self.config.$searchButtonAriaClose
				});
				self.toggleTransperantTopNav('show');
				self.config.$searchButtonIcon.removeClass('icon-search').addClass('icon-close');
				self.config.$searchInput.focus();
			}

		};

		return searchButton.init();

	})();

	return searchButton;
});
